import originFetch from './origin-fetch';
export default async <T>(
  url: string,
  param?: Record<string, any>,
  autoTip?: boolean,
  headers?: HeadersInit,
  responseType?: 'json' | 'blob' | 'text',
) => originFetch<T>(url, 'POST', param, headers, autoTip, responseType);
